import axios from "axios";
import { API_URL, API_URL_ANGULAR } from "../utils/Constant";
import { getUser } from "../utils/helpers";

export const generatePlateMap = async () => {
  try {
    let response = await axios.get(`${API_URL}/chemplatemap/`);

    let data = await response.data;

    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const getTestRules = async (test_name) => {
  try {
    const result = await axios.get(
      test_name
        ? `${API_URL}/chemexcelrules/?test_name=${test_name}`
        : `${API_URL}/chemexcelrules/`,
    );
    const resultsData = await result.data;
    const message = resultsData.message;
    if (message === "Success") {
      return {
        success: true,
        ...resultsData,
      };
    }
    return {
      success: false,
      message: resultsData?.message || "Something went wrong",
    };
  } catch (e) {
    const message = e?.response?.resultsData?.message || "Something went wrong";
    return {
      success: false,
      message,
    };
  }
};

export const generatePesticideReportData = async (payload) => {
  try {
    const user = getUser();
    const response = await axios.post(`${API_URL}/pesticidesdata/`, {
      list: payload, user_email: user.email, user_id: user.id, action: "Submit",
    });
    const data = await response.data;
    return {
      success: true, ...data, status_code: response.status, api_name: "pesticidesdata",
    };
  } catch (e) {
    const message = "Something went wrong.";
    return {
      success: false, status_code: e?.status_code ?? 400, message: e?.message ?? message, api_name: "pesticidesdata",
    };
  }
};

export const generateSpecialPesticideReportData = async (json) => {
  try {
    let response = await axios.get(`${API_URL}/specialpesticides/`, {
      params: {
        json,
      },
    });
    let data = await response.data;

    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const pendingQueue = async (payload, signal = null) => {
  try {
    let response = await axios.get(`${API_URL}/chem_results/`, {
      params: payload,
      signal,
    });

    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = { message: response.message, List: response.result[0].List };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message, canceled: e.code === "ERR_CANCELED" };
  }
};

export const chemQueue = async (target_date, query, signal = null) => {
  // chemqueue -> chemresults
  if (query && query.length > 0) {
    try {
      console.log("here");
      let response = await axios.get(`${API_URL}/chemqueue/`, {
        params: {
          date: target_date || "",
          input: query || "",
        },
        signal,
      });
      let data = await response.data;

      if (data && data.length > 0) {
        response = data[0];
        data = {
          list: response.result,
        };
      }
      // console.log(data);
      return { success: true, ...data };
    } catch (e) {
      const message = "Something went wrong.";
      return { success: false, message, canceled: e.code === "ERR_CANCELED" };
    }
  } else {
    try {
      let response = await axios.get(`${API_URL}/chemqueue/`, {
        params: {
          date: target_date || "",
        },
        signal,
      });

      let data = await response.data;
      if (data && data.length > 0) {
        response = data[0];
        data = {
          list: response.result,
        };
      }
      return { success: true, ...data };
    } catch (e) {
      const message = "Something went wrong.";
      return { success: false, message, canceled: e.code === "ERR_CANCELED" };
    }
  }
};

// checked on 1/5/22, is used in parseXcel, which is called by onSubmitProduct, which is
// passed into chemistrytab
// chemistry
export const updateResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/chemistry_results/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });
    const data = await result.data;
    return {
      success: true, ...data, status_code: result.status, api_name: "chemistry_results", message: "Success",
    };
  } catch (e) {
    console.log("error from updateProduct", e);
    return {
      success: false, status_code: e?.status_code ?? 400, message: e?.message ?? "Fail", api_name: "chemistry_results",
    };
  }
};

export const updateChemistryTestResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/ssannresults/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });

    // const result = await axios.post(`https://2c39-67-207-105-242.ngrok.io/checkPCR/api/testresults/`,{
    //   test_name: test_name,
    //   "list": list
    // })

    const data = await result.data;
    const res = { result: [] };
    if (data) {
      const elem = data;
      if (elem.result && elem.result.length > 0) {
        res.result = elem.result;
      }
    }
    return {
      success: true, ...res, status_code: result.status, api_name: "ssannresults", message: "Success",
    };
  } catch (e) {
    console.log("error from updateChemistryTestResults", e);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "ssannresults",
    };
  }
};

export const updatePolyphenolResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/chempp/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });

    const data = await result.data;
    const res = { result: [] };

    if (data) {
      const elem = data;
      if (elem.result && elem.result.length > 0) {
        res.result = elem.result;
      }
    }
    return {
      success: true, ...res, status_code: result.status, api_name: "chempp", message: "Success",
    };
  } catch (e) {
    console.log("error from updatePolyphenolResults", e);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "chempp",
    };
  }
};

export const updateMycotoxinResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/ssannresults/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });

    const data = await result.data;
    const res = { result: [] };
    if (data) {
      const elem = data;
      if (elem.result && elem.result.length > 0) {
        res.result = elem.result;
      }
    }
    return {
      success: true, ...res, status_code: result.status, api_name: "ssannresults", message: "Success",
    };
  } catch (e) {
    console.log("error from updateMycotoxinResults", e);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "ssannresults",
    };
  }
};

export const updateTitratableAcitidyResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/ssannresults/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });

    const data = await result.data;

    const res = { result: [] };
    if (data) {
      const elem = data;
      if (elem.result && elem.result.length > 0) {
        res.result = elem.result;
      }
    }
    return {
      success: true, ...res, status_code: result.status, api_name: "ssannresults", message: "Success",
    };
  } catch (e) {
    console.log("error from updateTitratableAcitidyResults", e);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "ssannresults",
    };
  }
};

export const updateSilverNitrateResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/ssannresults/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });

    const data = await result.data;
    const res = { result: [] };
    if (data) {
      const elem = data;
      if (elem.result && elem.result.length > 0) {
        res.result = elem.result;
      }
    }
    return {
      success: true, ...res, status_code: result.status, api_name: "ssannresults", message: "Success",
    };
  } catch (e) {
    console.log("error from updateSilverNitrateResults", e);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "ssannresults",
    };
  }
};

export const updatePunicalaginResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/chempp/`, {
      test_name,
      list,
      user_id: getUser()?.id,
    });

    const data = await result.data;
    const res = { result: [] };

    if (data) {
      const elem = data;
      if (elem.result && elem.result.length > 0) {
        res.result = elem.result;
      }
    }

    return {
      success: true, ...res, status_code: result.status, api_name: "chempp", message: "Success",
    };
  } catch (e) {
    console.log("error from updatePunicalaginResults", e);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "chempp",
    };
  }
};

// chemistry
export const updateMetalsResults = async (payload) => {
  try {
    const user = getUser();
    const result = await axios.post(`${API_URL}/metals_wet_chemistry/`, {
      ...payload,
      user_email: user.email,
    });
    const data = await result.data;
    if (data.message === "Success") {
      return {
        success: true, ...data, results: data.result ?? [], status_code: result.status, api_name: "metals_wet_chemistry",
      };
    }
    return {
      success: false, message: data?.message || "Something went wrong", status_code: result.status, api_name: "metals_wet_chemistry",
    };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "metals_wet_chemistry",
    };
  }
};

export const addNewTest = async (payload) => {
  try {
    const requestPayload = {
      test: payload.testName,
      units: payload.unit || "",
      result_type: payload.resultType,
      is_panel_test: payload.isPanelTest,
      is_ml: true,
      user_id: getUser()?.id,
    };

    const response = await axios.post(`${API_URL}/addchemtest/`, requestPayload);
    const data = response.data;
    const message = data.message;
    if (message === "Success") {
      return { success: true, message };
    }
    return { success: false, message };
  } catch (error) {
    const message = error?.response?.data?.message ?? "Something went wrong";
    return { success: false, message };
  }
};

export const editChemistryTest = async (payload) => {
  try {
    const response = await axios.patch(`${API_URL}/chemexcelrules/`, payload);
    const data = response.data;
    if (data?.message === "Updated") {
      return { success: true, message: data.message };
    }
    const message = data?.message || "Something went wrong";
    return { success: false, message };
  } catch (error) {
    const message = error?.response?.data?.message ?? "Something went wrong";
    return { success: false, message };
  }
};

export const deleteChemistryTest = async (testId) => {
  try {
    const response = await axios.delete(`${API_URL}/chemexcelrules/`, {
      params: { id: testId },
    });
    const data = response.data;
    const successMessage = data?.message || "Deleted";
    if (successMessage === "Deleted") {
      return { success: true, message: successMessage };
    }
    return { success: false, message: successMessage };
  } catch (error) {
    const message = error?.response?.data?.message ?? "Something went wrong";
    return { success: false, message };
  }
};

export const updateDynamicResults = async (list, test_name) => {
  try {
    const result = await axios.post(`${API_URL}/chemdynamicresults/`, {
      test: test_name,
      list,
      user_id: getUser()?.id,
    });
    const data = await result.data;
    return {
      success: true, ...data, status_code: result.status, api_name: "chemdynamicresults", message: "Success",
    };
  } catch (e) {
    console.log("error from updateDynamicResults", e, e.response);
    const message = "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "chemdynamicresults",
    };
  }
};
export const sendFapGenistaID = async (payload) => {
  try {
    const user = getUser();
    const response = await axios.get(`${API_URL}/fapresults/?genista_id=${payload}&user_id=${user.id}`);
    const data = response.data;
    const message = data.message;
    if (message === "Success") {
      return {
        success: true,
        message,
        status_code: response.status,
        api_name: "fapresults",
        sample_id: data.sample_id,
        sample_type: data.sample_type,
      };
    }
    return {
      success: false,
      message,
      ...data,
      api_name: "fapresults",
    };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return {
      success: false, message, status_code: e?.response?.status ?? 400, error_message: e?.message ?? "Fail", api_name: "fapresults",
    };
  }
};

/**
 * Validates Genista ID for Residual Solvents -USP and marks the test Ready.
 * Call once before PDF generation / S3 upload. Does not accept Excel or result rows.
 *
 * @param {string} genistaId
 * @returns {Promise<object>}
 */
export const sendResidualSolventsGenistaID = async (genistaId) => {
  try {
    if (!genistaId) {
      return {
        success: false,
        message: "genista_id is required",
        api_name: "residualsolventsresults",
      };
    }
    const user = getUser();
    if (!user?.id) {
      return {
        success: false,
        message: "user_id is required",
        api_name: "residualsolventsresults",
      };
    }
    const response = await axios.get(
      `${API_URL}/residualsolventsresults/?genista_id=${encodeURIComponent(genistaId)}&user_id=${encodeURIComponent(user.id)}`,
    );
    const data = response.data || {};
    const message = data.message;
    if (message === "Success") {
      return {
        success: true,
        message,
        status_code: response.status,
        api_name: "residualsolventsresults",
        genista_id: data.genista_id ?? genistaId,
        sample_id: data.sample_id,
        sample_type: data.sample_type,
      };
    }
    return {
      success: false,
      message: message || "Something went wrong.",
      ...data,
      api_name: "residualsolventsresults",
    };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return {
      success: false,
      message,
      status_code: e?.response?.status ?? 400,
      error_message: e?.message ?? "Fail",
      api_name: "residualsolventsresults",
    };
  }
};

export const processExcelResultsMl = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/process_excel_results_ml/`, payload);
    const data = await response.data;
    if (data.message === "Success") {
      return {
        success: true, ...data, message: data.message,
      };
    }
    return {
      success: false,
      ...data,
      message: data.message,
    };
  } catch (error) {
    const message = error?.response?.data?.message || "Something went wrong.";
    const errorPayload = error?.response?.data?.data !== null
      ? error?.response?.data?.data
      : {};
    return {
      success: false,
      ...errorPayload,
      message,
    };
  }
};

export const getTechnicianTests = async (tech_email, signal) => {
  try {
    const response = await axios.get(`${API_URL}/getexperts/?technician=${tech_email}`, { signal });
    const data = await response.data;
    return {
      success: true, ...data,
    };
  } catch (e) {
    const message = "Something went wrong.";
    return {
      success: false,
      message,
      status_code: e?.response?.status ?? 400,
      error_message: e?.message ?? "Fail",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

export const getInstruments = async () => {
  try {
    const response = await axios.get(`${API_URL}/getinstruments/`);
    const apiResponse = await response.data;
    return { success: true, ...apiResponse };
  } catch (e) {
    const message = "Failed to get instruments";
    return {
      success: false,
      message,
      status_code: e?.response?.status ?? 400,
      error_message: e?.message ?? "Fail",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

export const getPesticidesList = async (params, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/all_pesticides_samples/`, { params, signal });
    const apiResponse = await response.data;
    return { success: true, ...apiResponse };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

export const getPesticideSampleDetails = async (payload) => {
  try {
    const result = await axios.post(`${API_URL}/pesticide_sample_details/`, payload);
    const data = await result.data;
    return {
      success: true, ...data,
    };
  } catch (e) {
    const message = e?.message ?? "Something went wrong.";
    return {
      success: false,
      message,
      status_code: e?.response?.status ?? 400,
    };
  }
};

export const uploadPesticideReportData = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/pesticidesdata/`, payload);
    const data = await response.data;
    return {
      success: true, ...data, status_code: response.status, api_name: "pesticidesdata",
    };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return {
      success: false, status_code: e?.status_code ?? 400, message, api_name: "pesticidesdata",
    };
  }
};

export const getCommodityMrlValues = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/getmrlvaluesofcommodity/`, payload);
    const data = await response.data;
    return {
      success: true, ...data, status_code: response.status, api_name: "getmrlvaluesofcommodity/",
    };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return {
      success: false, status_code: e?.status_code ?? 400, message, api_name: "getmrlvaluesofcommodity/",
    };
  }
};

export const generatePesticideReportHeader = async (payload) => {
  try {
    const response = await axios.get(`${API_URL}/getpesticidereportheader/`, {
      params: payload,
    });
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return { success: false, message };
  }
};

export const submitPesticideReport = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/pesticidegeneratereport/`,
      payload,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return { success: false, message };
  }
};

export const pesticideGenerateReportBackend = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/pesticide_generate_report_backend/`,
      payload,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message
      || e?.response?.data?.error
      || e?.response?.data?.detail
      || "Something went wrong.";
    return { success: false, message };
  }
};

export const buildBackendReportPayload = (sampleDetail) => ({
  workorder_id: sampleDetail.workorder_id,
  genista_id: sampleDetail.genista_id,
  sample_id: sampleDetail.sample_id,
  tests_in_sample_id: sampleDetail.tests_in_sample_id,
  customer_id: sampleDetail.customer_id,
  test_name: sampleDetail.test_name,
  user_id: getUser().id,
});

export const getMissingBackendReportFields = (payload) => Object.entries(payload)
  .filter(([, value]) => value === undefined || value === null || value === "")
  .map(([key]) => key);

export const pesticideGenerateReportPreview = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/pesticide_generate_report_backend/`,
      {
        ...payload,
        preview: true,
      },
      {
        responseType: "blob",
      },
    );

    return {
      success: true,
      blob: response.data,
    };
  } catch (error) {
    let message = "Unable to generate the MRL preview.";
    const errorData = error?.response?.data;

    if (errorData instanceof Blob) {
      try {
        const errorText = await errorData.text();
        const parsedError = JSON.parse(errorText);
        message = parsedError.message
          || parsedError.error
          || parsedError.detail
          || message;
      } catch (parseError) {
        message = parseError ? "Unable to generate the MRL preview." : message;
      }
    } else {
      message = errorData?.message
        || errorData?.error
        || errorData?.detail
        || error?.message
        || message;
    }

    return {
      success: false,
      message,
    };
  }
};

export const markTestRunOnInstrument = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL}/chem_test_stages/`,
      payload,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.message ?? "Something went wrong.";
    return { success: false, message };
  }
};

export const fetchInstrumentSequences = async (payload, signal) => {
  try {
    const response = await axios.post(
      `${API_URL}/chemplatemaps/`,
      payload,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Something went wrong.";
    return {
      success: false, status_code: e?.status_code ?? 400, message, api_name: "pesticidesdata",
    };
  }
};

export const fetchActiveRA = async () => {
  try {
    const response = await axios.get(
      `${API_URL_ANGULAR}/technicians/?is_active=true&page=1&page_size=120`,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to fetch the Assigned To list.";
    return { success: false, message };
  }
};

/**
 * Fetches extracted Excel data
 * @param {object} payload - An object containing the params for the API request
 * @param {string} apiPath - Can be either 'generatesequence/' or 'generatesequenceagilent/'
 * @return {object} An object containing the API response and a success flag
 */
export const fetchSequenceData = async (payload, apiPath) => {
  try {
    const response = await axios.post(
      `${API_URL}/${apiPath}`,
      payload,
    );
    const { message, result } = await response.data;
    return { success: true, message, result };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to fetch the Sequence data";
    return { success: false, message };
  }
};

export const fetchTestCategory = async () => {
  try {
    const response = await axios.get(
      `${API_URL_ANGULAR}/tests/category_list/?ordering=contact_name&status=1`,
    );
    const data = await response.data;
    return { success: true, results: data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to fetch test categories";
    return { success: false, message };
  }
};

export const fetchInstrumentMethods = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/instrumentmethods/`,
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to fetch instrument methods";
    return { success: false, message };
  }
};

export const fetchSequenceTableData = async (signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/sequence_tests_ops_info/`,
      { signal },
    );
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to fetch sequence data";
    return { success: false, message, cancelled: e.code === "ERR_CANCELED" };
  }
};

export const editSequenceData = async (payload) => {
  try {
    const response = await axios.patch(
      `${API_URL}/sequence_tests_ops_info/`,
      payload,
    );
    const { message, result } = await response.data;
    return { success: true, message, result };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to update sequence data";
    return { success: false, message };
  }
};

/**
 * Send values from parsed excel file to api
 * @param {string} genistaID genistaio
 * @param {Object} testValues object containing test values
 */
export const sendParsedValues = async (genistaID, testValues) => {
  try {
    const result_list = testValues.slice(testValues.length - 7).map((test) => ({
      param: test.name,
      value: test.result,
    }));
    const user = getUser();
    const payload = {
      genista_id: genistaID,
      result_list,
      user_id: user.id,
    };
    const response = await axios.post(`${API_URL}/fapresults/`, payload);
    const data = response.data;
    const message = data.message;
    return { success: true, message, status_code: response.status };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return { success: false, message };
  }
};
